/* eslint-disable */
import messageTypes from '@ringcentral-integration/commons/enums/messageTypes';
export default {
  addLog: 'Lijst',
  editLog: 'Lijst bewerken',
  viewDetails: 'Details weergeven',
  addEntity: 'Nieuwe maken',
  call: 'Bellen',
  text: 'Tekstbericht',
  conversation: 'Gesprek',
  groupConversation: 'Groepsgesprek',
  voiceMessage: 'Spraakbericht',
  [messageTypes.voiceMail]: 'Voicemail',
  [messageTypes.fax]: 'Fax',
  mark: 'Markeren als ongelezen',
  unmark: 'Markeren als gelezen',
  delete: 'Verwijderen',
  faxSent: 'Fax verzonden',
  faxReceived: 'Fax ontvangen',
  pages: "pagina's",
  page: 'pagina',
  preview: 'Weergeven',
  download: 'Downloaden',
  mmsWithOneAttachment: 'Mms met 1 bijlage',
  mmsWithAttachments: 'Mms met {count} bijlagen',
} as const;

// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"conversation"@#@ @source: @#@"Conversation"@#@
// @key: @#@"groupConversation"@#@ @source: @#@"Group Conversation"@#@
// @key: @#@"voiceMessage"@#@ @source: @#@"Voice message"@#@
// @key: @#@"[messageTypes.voiceMail]"@#@ @source: @#@"Voice Mail"@#@
// @key: @#@"[messageTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"mark"@#@ @source: @#@"Mark as Unread"@#@
// @key: @#@"unmark"@#@ @source: @#@"Mark as Read"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"faxSent"@#@ @source: @#@"Fax sent"@#@
// @key: @#@"faxReceived"@#@ @source: @#@"Fax received"@#@
// @key: @#@"pages"@#@ @source: @#@"pages"@#@
// @key: @#@"page"@#@ @source: @#@"page"@#@
// @key: @#@"preview"@#@ @source: @#@"View"@#@
// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"mmsWithOneAttachment"@#@ @source: @#@"MMS with 1 attachment"@#@
// @key: @#@"mmsWithAttachments"@#@ @source: @#@"MMS with {count} attachments"@#@
